module.exports = __webpack_public_path__ + "img/tbguanzhu.b2cbf64d.jpg";